function AnalysisService($q, AppSettings, AuthService, CommonService) {
  'ngInject';

  const service = {};

  // 부상 정보 입력/수정
  service.setInjury = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'analysis/set_injury';

    return CommonService.post(url, params);
  };

  // 시간대별경기데이터
  service.game = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'analysis/game';

    return CommonService.post(url, params);
  };


  service.gameDetail = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'analysis/game_detail';

    return CommonService.post(url, params);
  };


  // 부상 목록
  service.getInjury = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'analysis/get_injury';

    return CommonService.post(url, params);
  };

  // 부상 정보 삭제
  service.removeInjury = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'analysis/remove_injury';

    return CommonService.post(url, params);
  };

  //경기장 위치 목록
  service.getLocationList = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'analysis/location_list';

    return CommonService.post(url, params);
  }

  // 위치 목록
  service.locations = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'analysis/locations';

    return CommonService.post(url, params);
  };

  // 동작 결과 입력
  service.setResult = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'analysis/set_result';

    return CommonService.post(url, params);
  };

  // 동작 추가
  service.addMovements = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'analysis/add_movement';

    return CommonService.post(url, params);
  }

  // 동작 삭제
  service.removeMovements = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'analysis/remove_movement';

    return CommonService.post(url, params);
  }

  //동작 기록 조회
  service.movements = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'analysis/movements';

    return CommonService.post(url, params);
  }

  //상대팀 주요기술패턴 조회
  service.patterns = function(params) {
    const url = AppSettings.apiUrl.restRoot + 'analysis/patterns';

    return CommonService.post(url, params);
  }

  //부상 패턴 조회
  service.injuryPatterns = function (params) {
    const url = AppSettings.apiUrl.restRoot + 'analysis/injury_patterns';

    return CommonService.post(url, params);
  }

  // analysis 앱 예측 데이터 조회 - 선수 한명, from, to 를 보내지 않으면 최근 params.limit 건수
  service.getPredictionData = function (params) {
    let url = 'http://eptsdev.codns.com:7724/epts/get_prediction_data_by_user_id/' + params.user_id;
    if (params.from) {
      url += '/' + params.from;
    }
    if (params.to) {
      url += '/' + params.to;
    }

    return CommonService.get(url, params);
  }

  // analysis 앱 예측 데이터 조회 - 선수 한명, 최근 10건
  service.getRecentPredictionData = function (params) {
    const url = 'http://eptsdev.codns.com:7724/epts/get_recent_prediction_data_by_user_id/' + params.user_id;

    return CommonService.get(url, params);
  }

  // analysis 앱 예측 데이터 조회 - 선수 여러명, from, to 를 보내지 않으면 최근 params.limit 건수
  service.getPlayersPredictionData = function (params) {
    let url = 'http://eptsdev.codns.com:7724/epts/get_prediction_data_by_user_ids';
    if (params.from) {
      url += '/' + params.from;
    }
    if (params.to) {
      url += '/' + params.to;
    }

    return CommonService.post(url, params);
  }

  // analysis 앱 예측 데이터 조회 - 선수 여러명, 최근 10건
  service.getRecentPlayersPredictionData = function (params) {
    const url = 'http://eptsdev.codns.com:7724/epts/get_recent_prediction_data_by_user_ids';

    return CommonService.post(url, params);
  }

  return service;

}

export default {
  name: 'AnalysisService',
  fn: AnalysisService
};
